import axios from 'axios';
import Handlebars from 'handlebars/dist/cjs/handlebars';
import { API_PATH } from '../../../../assets/js/constants';
import '../../../../assets/js/utils/handlebars-switch';
import '../../../../assets/js/utils/handlebars-ifCond';
import '../../../../assets/js/utils/handlebars-asset';
import '../../../../assets/js/utils/handlebars-truncate';
import GTM from '../../../../assets/js/components/gtm';

import immobile from '../json/index.json';

document.addEventListener('DOMContentLoaded', () => {
  // const selectors = {
  //     hbsSource         : 'hbs-template__js',
  //     hbsTemplate       : 'hbs-template',
  //     hbsSourceSelect   : 'hbs-template__js-select',
  //     hbsTemplateSelect : 'hbs-template-select',
  //     wrapper           : '.lp-products',
  //     select            : 'select-region',
  //     product           : '.immobile-list__item'
  // };
  //
  // const cssClasses = {
  //     loading   : 'is-loading',
  //     firstLoad : 'is-first-load'
  // };
  //
  // const arrProducts    = { products: [] };
  // const arrImmobile    = { immobile: [] };
  // const source         = document.getElementById(selectors.hbsSource).innerHTML;
  // const template       = Handlebars.compile(source);
  // const sourceSelect   = document.getElementById(selectors.hbsSourceSelect).innerHTML;
  // const templateSelect = Handlebars.compile(sourceSelect);
  //
  // const getProductList = (params) => {
  //     isLoading(true);
  //
  //     // console.log(params);
  //
  //     axios.get(`${API_PATH}/products`, { params: { ids : params } })
  //     .then((response) => {
  //         const data = response.data.data;
  //
  //         data.map((immobile) => arrProducts.products.push(immobile));
  //         document.getElementById(selectors.hbsTemplate).innerHTML = template(arrProducts);
  //
  //         onClickThumb();
  //         // console.log('DATA', data);
  //     })
  //     .catch((error) => console.log(error))
  //     .finally(() => isLoading(false));
  // };
  //
  // function initSelect() {
  //     immobile.regions[window.state].map((item) => arrImmobile.immobile.push(item));
  //     document.getElementById(selectors.hbsTemplateSelect).innerHTML = templateSelect(arrImmobile);
  //
  //     getProductList(arrImmobile.immobile[0].products.toString());
  // }
  //
  // document.getElementById(selectors.select).addEventListener('change', (evt) => {
  //     arrProducts.products = [];
  //     getProductList(evt.target.value);
  // });
  //
  // function onClickThumb() {
  //     Array.prototype.slice
  //         .call(document.querySelectorAll(selectors.product))
  //             .map((prod) => {
  //                 prod.addEventListener('click', (evt) => {
  //                     const prodID   = evt.currentTarget.getAttribute('data-product-attendanceid');
  //                     const prodName = evt.currentTarget.getAttribute('data-product-name');
  //
  //                     if (evt.target.classList.contains('is-chat')) {
  //                         evt.preventDefault();
  //                         window.startChat(prodID, '', '', '', '');
  //                     } else if (evt.target.classList.contains('is-whatsapp')) {
  //                         evt.preventDefault();
  //                         GTM('gaTriggerEvent', 'clique', 'whatsapp', 'Whatsapp_Sonho_de_Verao');
  //                         window.open(`https://api.whatsapp.com/send?phone=${window.whatsappNumber}&text=Gostaria de saber mais sobre Financiamento do Imóvel "${prodName}" - ID ${prodID}.`, '_blank');
  //                     }
  //                 }, false);
  //         });
  // };
  //
  // function isLoading(bool) {
  //     if (bool) {
  //         document.getElementById(selectors.select).disabled = true;
  //         document.getElementById(selectors.hbsTemplate).classList.add(cssClasses.loading);
  //     } else {
  //         if (document.querySelector(selectors.wrapper).classList.contains(cssClasses.firstLoad)) {
  //             document.querySelector(selectors.wrapper).classList.remove(cssClasses.firstLoad);
  //         }
  //
  //         document.getElementById(selectors.select).disabled = false;
  //         document.getElementById(selectors.hbsTemplate).classList.remove(cssClasses.loading);
  //     }
  // };
  //
  // initSelect();
});
